import { render, staticRenderFns } from "./store-checkout-summary.vue?vue&type=template&id=3071d20b&scoped=true"
import script from "./store-checkout-summary.vue?vue&type=script&lang=js"
export * from "./store-checkout-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3071d20b",
  null
  
)

export default component.exports